export const EMAIL_DELIVERED_COUNT = "emailDeliveredCount";
export const EMAIL_OPEN_COUNT =  "emailOpenCount";
export const EMAIL_CLICKED_COUNT = "emailClickedCount";